import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-loader" }
const _hoisted_2 = { class: "app-loader__loader" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "app-loader__bar" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_logo = _resolveComponent("app-logo")!

  return (_openBlock(), _createBlock(_Transition, { name: "app-loader-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_logo, {
            key: "loader-logo",
            shuffle: "",
            class: "app-loader__logo"
          }),
          _hoisted_3
        ])
      ])
    ]),
    _: 1
  }))
}